import cn from 'classnames';
import DOMPurify from 'dompurify';
import { useState, type MouseEventHandler } from 'react';
import { ModalLarge } from '@src/library/components/common';
import st from './styles.module.scss';
import '@widgets/shared/descriptionEditor/editorMainStyles.scss';
import { Close } from '@shared/assets/index.ts';
import { IconButton } from '@shared/ui/index.ts';

interface Props {
  htmlString: string;
  className?: string;
  type: 'all' | 'card' | 'profile' | 'formField';
  isViewPage?: boolean;
  onClick?: () => void;
  wrapperClassName?: string;
}

export const ViewerNoteEditorContent: React.FC<Props> = ({
  htmlString,
  className,
  type,
  onClick,
  wrapperClassName,
}) => {
  const sanitizedHtmlContent = DOMPurify.sanitize(htmlString);
  const [isOpenModal, setOpenModal] = useState(false);
  const [srcImg, setSrcImg] = useState('');
  const handleClickContent: MouseEventHandler<HTMLDivElement> = (e) => {
    const element = e.target as HTMLElement;

    if (element.tagName === 'A') {
      if (type === 'card') {
        e.preventDefault();
      } else {
        e.preventDefault();
        const link = element as HTMLAnchorElement;
        window.open(link.href, '_blank');
      }
    }
    if (element.tagName === 'IMG') {
      const img = element as HTMLImageElement;
      setSrcImg(img.src);
      setOpenModal(true);
    }
  };

  const handleClickClose = () => {
    setOpenModal(false);
    document.body.style.overflow = 'unset';
  };

  return (
    <>
      <div className={cn(st.wrapper, wrapperClassName)} onClick={onClick}>
        <div
          onClick={handleClickContent}
          className={cn(`${st[type]}`, className)}
          dangerouslySetInnerHTML={{ __html: sanitizedHtmlContent }}
        ></div>
      </div>
      {isOpenModal && (
        <ModalLarge
          isOpen={isOpenModal}
          close={handleClickClose}
          onRequestClose={handleClickClose}
          disableHeader
        >
          <section className={st.modalWrapper}>
            <img alt="modalImage" src={srcImg} className={st.modalImg} />
            <IconButton className={st.modalCloseButton} onClick={handleClickClose} variant={'dark'}>
              <Close />
            </IconButton>
          </section>
        </ModalLarge>
      )}
    </>
  );
};
